export default __webpack_public_path__ + "static/media/bouncing-balls-no-1.8b0fb17d.mid";